import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import TellyChannelLogo from '../../../images/app-store-icon.png';
import * as ModalActions from '../../../stores/actions/modal';
import { OpenTokContext } from '../../../contexts/opentok/opentok-context';

export default function ProgramFeed(): JSX.Element {
	const dispatch = useDispatch();
	const { opentok } = useContext(OpenTokContext);

	const closeModal = () => {
		// opentok tries to start audio contexts for subscribers
		// these contexts need to resume after making a gesture
		// https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API/Best_practices#autoplay_policy
		if (opentok?.subscribers) {
			Object.entries(opentok?.subscribers).forEach(([, subscriber]) => {
				subscriber._.unblockAudio();
			});
		}
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<div className="info-modal program-feed-modal">
			<div className="title-container">
				<div className="telly-channel-bubble">
					<img src={TellyChannelLogo} alt='telly'></img>
				</div>
				<span>View Program Feed</span>
			</div>

			<span className="header">A workflow tool for greenroom producers</span>

			<div className='body'>
				<span className="explanation">The program feed allows users to view the canvas in real time for additional workflows. These include:</span>

				<ul className="explanation-list">
					<li>Local Recording</li>
					<li>In person audiences</li>
					<li>Broadcast tool layering</li>
				</ul>

				<a className='learn-more' href='https://help.brand.live/hc/en-us/articles/1500009454041-Program-Feed'>Learn more about Greenroom’s Program Feed</a>
			</div>

			<div className='footer'>
				<button className='view-btn' data-testid="program-feed-modal-view-button" onClick={() => closeModal()}>View</button>
			</div>
		</div>
	);
}
